<template>
  <b-modal
    title="Assign Token"
    centered
    hide-footer
    v-model="show"
    class="pa-4"
    :style="'width: 708px !important;'"
    @hide="onHide"
  >
    <div v-if="tradieToAssign">
      <p class="mt-0 mb-3">
        Assign a token to
        <b>{{ tradieToAssign.full_name || tradieToAssign.email }}</b>
        ?
      </p>
      <div
        v-if="[0, null].includes(tradieToAssign.accepted)"
        class="alert alert-warning mb-3 text-center"
      >
        <p class="mb-0">
          <strong>Warning:</strong> This person hasn't accepted your invitation
          yet.
        </p>
        <p class="mb-0">Are you sure you want to assign a token?</p>
      </div>
    </div>

    <div v-if="balance && balance.available > 0" class="mb-3 mt-2">
      <span :style="tokenColour">
        Available tokens:
        <strong>{{ balance.available }}</strong>
      </span>
    </div>
    <div v-else class="alert alert-warning mb-3 text-center">
      <p class="mb-0">You don't have any available tokens</p>
      <p v-if="canPurchaseTokens" class="mb-0">
        Would you like to purchase tokens?
      </p>
    </div>

    <div
      class="token-actions d-flex justify-content-center align-items-stretch pt-2"
    >
      <b-button
        v-if="balance && balance.available > 0"
        type="submit"
        variant="primary"
        class="token-btn token-btn--primary"
        :disabled="balance.available < 0"
        @click="onAssign"
      >
        ASSIGN
      </b-button>
      <b-button
        v-else-if="canPurchaseTokens"
        variant="primary"
        class="token-btn token-btn--primary"
        @click="onPurchaseTokens"
      >
        PURCHASE TOKENS
      </b-button>
      <b-button
        variant="outline-secondary"
        class="token-btn token-btn--cancel"
        @click="onClose"
      >
        <span class="d-none d-sm-inline">CANCEL</span>
        <b-icon icon="x" class="d-sm-none" font-scale="1.6" />
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { canBuyTokens } from '@/utils/tokenAccess'
import { mapGetters } from 'vuex'

export default {
  name: 'AssignTokenModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    tradieToAssign: {
      type: Object,
      default: null,
    },
  },

  computed: {
    ...mapGetters('token', ['balance']),
    ...mapGetters('auth', ['user', 'hasPermission']),

    canPurchaseTokens() {
      return canBuyTokens(this.user, this.hasPermission)
    },

    show: {
      get() {
        return this.showModal
      },
      set(value) {
        this.$emit('closeModal')
      },
    },

    tokenColour() {
      if (this.balance && this.balance.available !== undefined) {
        if (this.balance.available <= 3) {
          return {
            backgroundColor: '#dc3545',
            color: '#ffffff',
            padding: '8px 16px',
            borderRadius: '6px',
            display: 'inline-block',
            fontWeight: '500',
          }
        } else if (this.balance.available > 3 && this.balance.available <= 10) {
          return {
            backgroundColor: '#ffc107',
            color: '#000000',
            padding: '8px 16px',
            borderRadius: '6px',
            display: 'inline-block',
            fontWeight: '500',
          }
        }
      }
      return {
        backgroundColor: '#28a745',
        color: '#ffffff',
        padding: '8px 16px',
        borderRadius: '6px',
        display: 'inline-block',
        fontWeight: '500',
      }
    },
  },

  methods: {
    onHide() {
      this.$emit('closeModal')
    },

    onClose() {
      this.$emit('closeModal')
    },

    onAssign() {
      this.$emit('assign')
    },

    onPurchaseTokens() {
      this.$emit('purchaseTokens')
    },
  },
}
</script>

<style lang="scss" scoped>
strong {
  color: inherit;
}

/* Action buttons stay on one line. On larger screens they're centred with a
   full "CANCEL"; on phones the text shrinks, the gap tightens, and cancel
   collapses to a compact "×" so the primary action takes the room. */
.token-actions {
  gap: 0.5rem;
}
.token-btn {
  font-weight: 600;
}
.token-btn--primary {
  min-width: 132px;
}

@media (max-width: 575.98px) {
  .token-actions {
    gap: 0.35rem;
  }
  .token-btn {
    font-size: 0.8rem;
    padding: 0.4rem 0.6rem;
  }
  .token-btn--primary {
    flex: 1 1 auto;
    min-width: 0;
  }
  .token-btn--cancel {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.4rem 0.6rem;
  }
}
</style>
